<script>
  import { onMount } from "svelte"
  import { navigate } from "svelte-routing"
  import AgregarCliente from "../components/crm/Agregar_cliente.svelte"
  import ClienteConsulta from "../components/crm/Cliente_consulta.svelte"
  import Segmentos from "../components/crm/Segmentos.svelte"
  import Productos from "../components/crm/Productos.svelte"
  import Footer from "../components/Footer.svelte"
  import Header from "../components/Header.svelte"
  import Modal from "../components/Modal.svelte"
  import Sidebar from "../components/Sidebar.svelte"
  import Container from "../components/Container.svelte"
  import SinInformacion from "../components/Sin_informacion.svelte"
  import Spinner from "../components/Spinner.svelte"
  import { BASE_URL } from "../stores/BASE_URL"
  import { user } from "../stores/User"
  import getMoneda, { redondear } from "../services/moneda.js"
  import { verifySession } from "../services/verifySession"
  import { Datatable } from "svelte-simple-datatables"

  let clientes = []
  let clientes_filtrados = []
  let segmentosActivos = []

  let btn_etapas = [
    { value: "Todos", label: "Mostrar todos", color: "primary" },
    { value: "Posible cliente", label: "Posible cliente", color: "secondary" },
    { value: "En proceso", label: "En proceso", color: "yellow" },
    { value: "Cierre", label: "Cierre", color: "success" },
    { value: "Perdido", label: "Perdido", color: "danger" },
    { value: "Postventa", label: "Post venta", color: "neutral" },
  ]
  let btn_selected = "Todos"

  let isOpenModalSegmentos = false
  let isOpenModalCliente = false
  let isOpenModalProductos = false

  let isLoading = false

  let modoAdmin = false
  let clienteConsulta = null
  let pestañaActiva = "clientes"

  $: if (modoAdmin) pestañaActiva = "clientes"
  $: if (!modoAdmin) clienteConsulta = null
  let vendedores = []
  let vendedor = "0"

  // Abreviaturas de meses en español
  const meses = [
    { value: "01", label: "ENE" },
    { value: "02", label: "FEB" },
    { value: "03", label: "MAR" },
    { value: "04", label: "ABR" },
    { value: "05", label: "MAY" },
    { value: "06", label: "JUN" },
    { value: "07", label: "JUL" },
    { value: "08", label: "AGO" },
    { value: "09", label: "SEP" },
    { value: "10", label: "OCT" },
    { value: "11", label: "NOV" },
    { value: "12", label: "DIC" },
  ]

  let year = ""
  let month = ""

  let clientes_admin = []
  let clientes_admin_filtrados = []

  const settings = {
    sortable: true,
    pagination: true,
    rowsPerPage: 15,
    columnFilter: false,
    scrollY: false,
    blocks: {
      searchInput: false,
      paginationButtons: true,
      paginationRowCount: false,
    },
    labels: {
      previous: "Anterior",
      next: "Siguiente",
    },
  }

  let rows
  let rows_admin
  let pendingRequests = 0
  let clientesRequestId = 0
  let clientesAdminRequestId = 0
  let clientesTableVersion = 0
  let clientesAdminTableVersion = 0

  $: clientesTableKey = `user-${btn_selected}-${year}-${month}-${clientesTableVersion}`
  $: clientesAdminTableKey = `admin-${vendedor}-${btn_selected}-${year}-${month}-${clientesAdminTableVersion}`

  const startLoading = () => {
    pendingRequests += 1
    isLoading = true
  }

  const stopLoading = () => {
    pendingRequests = Math.max(0, pendingRequests - 1)
    isLoading = pendingRequests > 0
  }

  const buildCrmUrl = (params) => {
    const query = new URLSearchParams({
      ...params,
      session_key: $user.session_key,
    })

    return `${BASE_URL}crm.php?${query.toString()}`
  }

  const mesesPorTexto = {
    ene: "01",
    enero: "01",
    feb: "02",
    febrero: "02",
    mar: "03",
    marzo: "03",
    abr: "04",
    abril: "04",
    may: "05",
    mayo: "05",
    jun: "06",
    junio: "06",
    jul: "07",
    julio: "07",
    ago: "08",
    agosto: "08",
    sep: "09",
    set: "09",
    septiembre: "09",
    oct: "10",
    octubre: "10",
    nov: "11",
    noviembre: "11",
    dic: "12",
    diciembre: "12",
  }

  let monto_total = 0
  let monto_total_admin = 0

  let adicional_total = 0
  let adicional_total_admin = 0

  const normalizarMes = (valor) => {
    const mes = String(valor ?? "")
      .trim()
      .toLowerCase()
    if (!mes) return ""

    const numeroMes = parseInt(mes, 10)
    if (!isNaN(numeroMes)) return String(numeroMes).padStart(2, "0")

    return mesesPorTexto[mes] ?? mes
  }

  const normalizarTexto = (valor) => {
    return String(valor ?? "")
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, " ")
  }

  const etapaPorClasificacion = {
    nuevo: "Posible cliente",
    contactado: "Posible cliente",
    calificado: "En proceso",
    "propuesta enviada": "En proceso",
    demostracion: "En proceso",
    "en negociacion": "En proceso",
    acuerdo: "Cierre",
    "acuerdo exitoso": "Cierre",
    "cliente perdido": "Perdido",
    fidelizacion: "Postventa",
  }

  const obtenerEtapaCliente = (cliente) => {
    const etapa = String(cliente.etapa ?? cliente.nombre_etapa ?? "").trim()
    const etapaNormalizada = normalizarTexto(etapa)

    if (etapaNormalizada === "post venta") return "Postventa"
    if (etapa) return etapa

    return etapaPorClasificacion[normalizarTexto(cliente.clasificacion)] ?? ""
  }

  const coincideEtapa = (cliente, etapa) => {
    return (
      normalizarTexto(obtenerEtapaCliente(cliente)) === normalizarTexto(etapa)
    )
  }

  const getEtapaColor = (cliente) => {
    const etapaCliente = obtenerEtapaCliente(cliente)
    return (
      btn_etapas.find(
        (btn) => normalizarTexto(btn.value) === normalizarTexto(etapaCliente),
      )?.color ?? "neutral"
    )
  }

  const obtenerPeriodoCliente = (cliente) => {
    const yearCliente =
      cliente.year ?? cliente.anio ?? cliente.ano ?? cliente.año
    const monthCliente = cliente.month ?? cliente.mes

    if (yearCliente && monthCliente) {
      return {
        year: String(yearCliente ?? "").trim(),
        month: normalizarMes(monthCliente),
      }
    }

    const fecha = String(
      cliente.fecha_creacion ??
        cliente.fecha ??
        cliente.created_at ??
        cliente.fecha_registro ??
        "",
    ).trim()

    const fechaIso = fecha.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})/)
    if (fechaIso) {
      return {
        year: fechaIso[1],
        month: normalizarMes(fechaIso[2]),
      }
    }

    const fechaLatam = fecha.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})/)
    if (fechaLatam) {
      return {
        year: fechaLatam[3],
        month: normalizarMes(fechaLatam[2]),
      }
    }

    return null
  }

  const filtrarPorPeriodo = (lista) => {
    return lista.filter((c) => {
      if (year == "" && month == "") {
        return true
      }

      const periodo = obtenerPeriodoCliente(c)
      if (!periodo) return true

      if (year != "" && periodo.year != year) return false
      if (month != "" && periodo.month != normalizarMes(month)) return false

      return true
    })
  }

  // === Funciones principales ===
  const getClientes = async () => {
    const requestId = ++clientesRequestId
    startLoading()

    try {
      const response = await fetch(buildCrmUrl({ ops: "getClientes" }))
      const data = await response.json()
      if (requestId !== clientesRequestId) return

      if (data.status === "ok") {
        clientes = Array.isArray(data.data) ? data.data : []
      } else {
        clientes = []
      }

      clientesTableVersion += 1
    } catch (error) {
      if (requestId !== clientesRequestId) return
      console.error("Error al obtener clientes:", error)
      clientes = []
      clientesTableVersion += 1
    } finally {
      stopLoading()
    }
  }

  const aplicarFiltros = () => {
    if (btn_selected === "Todos") {
      clientes_filtrados = clientes.filter(
        (c) => !coincideEtapa(c, "Postventa"),
      )
      clientes_admin_filtrados = clientes_admin.filter(
        (c) => !coincideEtapa(c, "Postventa"),
      )
    } else {
      clientes_filtrados = clientes.filter((c) =>
        coincideEtapa(c, btn_selected),
      )
      clientes_admin_filtrados = clientes_admin.filter((c) =>
        coincideEtapa(c, btn_selected),
      )
    }

    clientes_filtrados = filtrarPorPeriodo(clientes_filtrados)
    clientes_admin_filtrados = filtrarPorPeriodo(clientes_admin_filtrados)

    monto_total = clientes_filtrados.reduce(
      (total, cliente) => total + (parseFloat(cliente.monto) || 0),
      0,
    )
    monto_total_admin = clientes_admin_filtrados.reduce(
      (total, cliente) => total + (parseFloat(cliente.monto) || 0),
      0,
    )

    adicional_total = clientes_filtrados.reduce(
      (total, cliente) => total + (parseFloat(cliente.monto_adicional) || 0),
      0,
    )
    adicional_total_admin = clientes_admin_filtrados.reduce(
      (total, cliente) => total + (parseFloat(cliente.monto_adicional) || 0),
      0,
    )
  }

  const getClientesAdmin = async () => {
    const requestId = ++clientesAdminRequestId
    const selectedVendedor = vendedor
    startLoading()

    try {
      const response = await fetch(
        buildCrmUrl({ ops: "getClientes", vendedor: selectedVendedor }),
      )
      const data = await response.json()
      if (requestId !== clientesAdminRequestId) return

      if (data.status === "ok") {
        clientes_admin = Array.isArray(data.data) ? data.data : []
      } else {
        clientes_admin = []
      }

      clientesAdminTableVersion += 1
    } catch (error) {
      if (requestId !== clientesAdminRequestId) return
      console.error("Error al obtener clientes admin:", error)
      clientes_admin = []
      clientesAdminTableVersion += 1
    } finally {
      stopLoading()
    }
  }

  const deleteCliente = async (id) => {
    if (confirm("¿Estás seguro de eliminar este cliente?")) {
      const response = await fetch(`${BASE_URL}crm.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id,
          ops: "deleteCliente",
          session_key: $user.session_key,
        }),
      })
      const data = await response.json()
      if (data.status === "ok") {
        alert("Cliente eliminado correctamente")
        getClientes()
      } else {
        alert("Error al eliminar el cliente")
      }
    }
  }

  const handleAgregarSegmento = () => (isOpenModalSegmentos = true)
  const handleAgregarCliente = () => (isOpenModalCliente = true)
  const handleAgregarProducto = () => (isOpenModalProductos = true)

  const getVendedores = async () => {
    const response = await fetch(buildCrmUrl({ ops: "getVendedores" }))
    const data = await response.json()
    vendedores = data.status === "ok" ? data.data : []
  }

  const getPuntos = async () => {
    const response = await fetch(
      `${BASE_URL}session.php?session_key=${$user.session_key}`,
    )
    const resp = await response.json()

    if (resp.status === "success") {
      let temp_user = $user
      temp_user.consumo = resp.data.consumo
      temp_user.consultas = resp.data.consultas
      temp_user.inicio = resp.data.inicio
      temp_user.fin = resp.data.fin
      user.setUser(temp_user)
    } else {
      navigate("/", { replace: true })
    }
  }

  // === Reaccion al cambio de datos o filtros ===
  $: {
    btn_selected
    year
    month
    clientes
    clientes_admin
    aplicarFiltros()
  }

  // === Reacción al cambio de modo o vendedor ===
  const handleModoChange = async () => {
    if (modoAdmin) {
      await getClientesAdmin()
    } else {
      clientesAdminRequestId += 1
      await getClientes()
    }
  }

  const handleVendedorChange = async () => {
    await getClientesAdmin()
  }

  // === Carga inicial ===
  onMount(async () => {
    if (!$user) {
      navigate("/", { replace: true })
      return
    }

    verifySession($user.session_key)
    getPuntos()
    getVendedores()

    if (!$user.permisos.includes("crm")) {
      user.setUser(null)
      navigate("/", { replace: true })
    }

    if ($user.actualizar_clave == "1") navigate("/seguridad", { replace: true })
    if ($user.verificar == "1") navigate("/verificar", { replace: true })

    // Carga inicial de clientes
    await getClientes()
    await getClientesAdmin()
  })
</script>

{#if $user}
  <main class="d-flex flex-column md:flex-row page-shell">
    <Sidebar />
    <div class="d-flex flex-column flex-grow-1 page-content">
      <Header />

      <div class="container-fluid py-5 bg-2">
        <div class="d-flex flex-wrap align-items-center gap-3">
          <div class="alert theme-warning d-flex gap-5 py-1">
            {#if modoAdmin}
              <h6 class="small my-0 fg-primary">Total >></h6>
              <h6 class="small my-0 fg-3">
                Monto: S/ {getMoneda(redondear(monto_total_admin))}
              </h6>
              <h6 class="small my-0 fg-3">
                Adicional: S/ {getMoneda(redondear(adicional_total_admin))}
              </h6>
            {:else}
              <h6 class="small my-0 fg-primary">Total >></h6>
              <h6 class="small my-0 fg-3">
                Monto: S/ {getMoneda(redondear(monto_total))}
              </h6>
              <h6 class="small my-0 fg-3">
                Adicional: S/ {getMoneda(redondear(adicional_total))}
              </h6>
            {/if}
          </div>
          <div class="ms-auto">
            {#if $user.rol === "1"}
              <div class="text-end">
                <div
                  class="d-flex align-items-center gap-5 justify-content-end"
                >
                  <span class={modoAdmin ? "fg-3 small" : "fw-medium small"}>
                    <i class="bi bi-person-fill"></i> Usuario
                  </span>

                  <div class="switch switch-sm">
                    <input
                      role="switch"
                      type="checkbox"
                      bind:checked={modoAdmin}
                      id="modoAdminSwitch"
                      on:change={handleModoChange}
                    />
                  </div>

                  <span class={modoAdmin ? "fw-medium small" : "fg-3 small"}>
                    <i class="bi bi-shield-lock-fill"></i> Administrador
                  </span>
                </div>
              </div>
            {/if}
          </div>
        </div>

        <div class="d-flex flex-wrap align-items-center gap-3 mt-3">
          <ul class="nav nav-tabs" id="pills-tab-e" role="tablist">
            {#if modoAdmin}
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link active"
                  id="pills-clientes-tab-e"
                  on:click={() => (pestañaActiva = "clientes")}
                  type="button"
                  role="tab"
                  aria-controls="pills-clientes-e"
                  aria-selected="true">Clientes</button
                >
              </li>
            {:else}
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  class:active={pestañaActiva === "clientes"}
                  id="pills-clientes-tab-e"
                  on:click={() => (pestañaActiva = "clientes")}
                  type="button"
                  role="tab"
                  aria-controls="pills-clientes-e"
                  aria-selected={pestañaActiva === "clientes"}
                  ><i class="bi bi-person-check me-1"></i> Clientes</button
                >
              </li>
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  class:active={pestañaActiva === "segmentos"}
                  id="pills-segmentos-tab-e"
                  on:click={() => (pestañaActiva = "segmentos")}
                  type="button"
                  role="tab"
                  aria-controls="pills-segmentos-e"
                  aria-selected={pestañaActiva === "segmentos"}
                  ><i class="bi bi-diagram-3 me-1"></i> Segmentos</button
                >
              </li>
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  class:active={pestañaActiva === "productos"}
                  id="pills-productos-tab-e"
                  on:click={() => (pestañaActiva = "productos")}
                  type="button"
                  role="tab"
                  aria-controls="pills-productos-e"
                  aria-selected={pestañaActiva === "productos"}
                  ><i class="bi bi-box-seam me-1"></i> Productos</button
                >
              </li>
            {/if}
          </ul>
        </div>
        <Container>
          <div class="tab-content" id="pills-tabContent-e">
            <div
              class="tab-pane fade"
              class:show={pestañaActiva === "clientes"}
              class:active={pestañaActiva === "clientes"}
              id="pills-clientes-e"
              role="tabpanel"
              aria-labelledby="pills-clientes-tab-e"
            >
              <!-- Controles superiores -->
              <div class="d-flex justify-content-between flex-wrap gap-1 mb-5">
                <div
                  class="d-flex justify-content-between flex-wrap align-items-center gap-5"
                >
                  {#if modoAdmin}
                    <div class="d-flex align-items-center gap-1">
                      <label
                        class="form-label fg-secondary small my-0 me-3"
                        for="crm_vendedor"
                      >
                        Usuario:
                      </label>
                      <select
                        class="form-control form-control-sm w-auto"
                        id="crm_vendedor"
                        bind:value={vendedor}
                        on:change={handleVendedorChange}
                      >
                        <option value="0">TODOS</option>
                        {#each vendedores as v}
                          <option value={v.usuario}>{v.nombres}</option>
                        {/each}
                      </select>
                    </div>
                  {:else}
                    <button
                      class="btn btn-solid theme-primary btn-sm"
                      on:click={handleAgregarCliente}
                      ><i class="bi bi-person-plus-fill"></i>
                      Agregar cliente
                    </button>
                  {/if}

                  <div class="d-flex align-items-center gap-3">
                    <span class="fg-secondary small">Periodo: </span>
                    <select
                      class="form-control form-control-sm w-auto"
                      bind:value={year}
                      on:change={() => {
                        month = ""
                      }}
                    >
                      <option value="">Mostrar todo</option>
                      {#each Array(new Date().getFullYear() - 2024)
                        .fill(0)
                        .map((_, i) => 2025 + i) as year}
                        <option value={year}>{year}</option>
                      {/each}
                    </select>
                    <select
                      class="form-control form-control-sm w-auto"
                      bind:value={month}
                    >
                      <option value="">Mostrar todo</option>
                      {#if year != ""}
                        {#each meses as mes}
                          <option value={mes.value}>{mes.label}</option>
                        {/each}
                      {/if}
                    </select>
                  </div>
                </div>

                <!-- Botones de etapas -->
                <div class="d-flex flex-wrap gap-1">
                  {#each btn_etapas as btn}
                    <button
                      class="btn btn-solid theme-{btn.color} btn-sm"
                      on:click={() => (btn_selected = btn.value)}
                    >
                      {btn.label}
                      {#if btn_selected === btn.value}
                        <i class="bi bi-check-circle-fill ms-1"></i>
                      {:else}
                        <i class="bi bi-circle ms-1 opacity-25"></i>
                      {/if}
                    </button>
                  {/each}
                </div>
              </div>

              <!-- Tabla principal -->
              {#if modoAdmin}
                {#key clientesAdminTableKey}
                  <Datatable
                    {settings}
                    data={clientes_admin_filtrados}
                    bind:dataRows={rows_admin}
                  >
                    <table class="table table-striped table-sm small">
                      <thead>
                        <tr>
                          <th class="fg-secondary fw-normal">Usuario</th>
                          <th class="fg-secondary fw-normal">Cliente</th>
                          <th class="fg-secondary fw-normal">Compañía</th>
                          <th class="fg-secondary fw-normal text-end">Monto</th>
                          <th class="fg-secondary fw-normal text-end"
                            >Adicional</th
                          >
                          <th class="fg-secondary fw-normal text-center"
                            >Segmento</th
                          >
                          <th class="fg-secondary fw-normal"
                            >Etapa / Clasificación</th
                          >
                          <th class="fg-secondary fw-normal text-center"
                            >Fecha creación</th
                          >
                          <th class="fg-secondary fw-normal text-center"
                            >Probabilidad %</th
                          >
                          <th class="fg-secondary fw-normal">Último contacto</th
                          >
                        </tr>
                      </thead>
                      <tbody>
                        {#if isLoading}
                          <tr>
                            <td colspan="10" class="text-center"><Spinner /></td
                            >
                          </tr>
                        {:else if rows_admin && $rows_admin.length > 0}
                          {#each $rows_admin as cliente}
                            <tr>
                              <td class={cliente.estado == "0" ? "fg-3" : ""}>
                                {cliente.vendedor}
                              </td>
                              <td
                                class="td-hover fg-primary"
                                class:fg-3={cliente.estado == "0"}
                                role="button"
                                tabindex="0"
                                aria-label={`Ver información registrada de ${cliente.nombres}`}
                                on:click={() => (clienteConsulta = cliente)}
                                on:keydown={(event) => {
                                  if (
                                    event.key === "Enter" ||
                                    event.key === " "
                                  ) {
                                    event.preventDefault()
                                    clienteConsulta = cliente
                                  }
                                }}
                              >
                                {cliente.nombres}
                              </td>
                              <td
                                class={cliente.estado == "0"
                                  ? "fg-3 limitar-texto"
                                  : "limitar-texto"}
                              >
                                {cliente.laboral_razon_social}
                              </td>
                              <td
                                class={cliente.estado == "0"
                                  ? "fg-3 text-end"
                                  : "text-end"}
                              >
                                {getMoneda(cliente.monto)}
                              </td>
                              <td
                                class={cliente.estado == "0"
                                  ? "fg-3 text-end"
                                  : "text-end"}
                              >
                                {getMoneda(cliente.monto_adicional)}
                              </td>
                              <td
                                class={cliente.estado == "0"
                                  ? "fg-3 text-center"
                                  : "text-center"}
                              >
                                {cliente.segmento}
                              </td>
                              <td
                                class="small theme-{getEtapaColor(
                                  cliente,
                                )} {cliente.estado == '0' ? 'fg-3' : ''}"
                              >
                                {obtenerEtapaCliente(cliente)} /
                                <small class="fst-italic"
                                  >{cliente.clasificacion}</small
                                >
                              </td>
                              <td
                                class={cliente.estado == "0"
                                  ? "fg-3 text-center"
                                  : "text-center"}>{String(cliente.fecha_creacion ?? "").split(/[T\s]/)[0]}</td
                              >
                              <td
                                class={cliente.estado == "0"
                                  ? "fg-3 text-center"
                                  : "text-center"}
                              >
                                {cliente.probabilidad}%
                              </td>
                              <td
                                class={cliente.estado == "0"
                                  ? "fg-3"
                                  : "text-start"}
                              >
                                {cliente.fecha_actualizacion ?? ""}
                              </td>
                            </tr>
                          {/each}
                        {:else}
                          <tr>
                            <td colspan="10" class="text-center">
                              <SinInformacion
                                message="No hay clientes para mostrar"
                              />
                            </td>
                          </tr>
                        {/if}
                      </tbody>
                    </table>
                  </Datatable>
                {/key}
              {:else}
                {#key clientesTableKey}
                  <Datatable
                    {settings}
                    data={clientes_filtrados}
                    bind:dataRows={rows}
                  >
                    <table class="table table-striped table-sm small">
                      <thead>
                        <tr>
                          <th class="fg-secondary fw-normal">Cliente</th>
                          <th class="fg-secondary fw-normal">Compañía</th>
                          <th class="fg-secondary fw-normal text-end">Monto</th>
                          <th class="fg-secondary fw-normal text-end"
                            >Adicional</th
                          >
                          <th class="fg-secondary fw-normal text-center"
                            >Segmento</th
                          >
                          <th class="fg-secondary fw-normal"
                            >Etapa / Clasificación</th
                          >
                          <th class="fg-secondary fw-normal text-center"
                            >Fecha creación</th
                          >
                          <th class="fg-secondary fw-normal text-center"
                            >Probabilidad %</th
                          >
                          <th class="fg-secondary fw-normal">Último contacto</th
                          >
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {#if isLoading}
                          <tr>
                            <td colspan="10" class="text-center"><Spinner /></td
                            >
                          </tr>
                        {:else if rows && $rows.length > 0}
                          {#each $rows as cliente}
                            <tr>
                              <td
                                class={cliente.estado == "1"
                                  ? "td-hover fg-primary"
                                  : "fg-3"}
                                on:click={() => {
                                  if (cliente.estado == "1")
                                    navigate(`/crm/${cliente.id}`, {
                                      replace: true,
                                    })
                                }}
                              >
                                {cliente.nombres}
                              </td>
                              <td
                                class={cliente.estado == "0"
                                  ? "fg-3 limitar-texto"
                                  : "limitar-texto"}
                              >
                                {cliente.laboral_razon_social}
                              </td>
                              <td
                                class={cliente.estado == "0"
                                  ? "fg-3 text-end"
                                  : "text-end"}
                              >
                                {getMoneda(cliente.monto)}
                              </td>
                              <td
                                class={cliente.estado == "0"
                                  ? "fg-3 text-end"
                                  : "text-end"}
                              >
                                {getMoneda(cliente.monto_adicional)}
                              </td>
                              <td
                                class={cliente.estado == "0"
                                  ? "fg-3 text-center"
                                  : "text-center"}
                              >
                                {cliente.segmento}
                              </td>
                              <td
                                class="small theme-{getEtapaColor(
                                  cliente,
                                )} {cliente.estado == '0' ? 'fg-3' : ''}"
                              >
                                {obtenerEtapaCliente(cliente)} /
                                <small class="fst-italic"
                                  >{cliente.clasificacion}</small
                                >
                              </td>
                              <td
                                class={cliente.estado == "0"
                                  ? "fg-3  text-center"
                                  : " text-center"}>{String(cliente.fecha_creacion ?? "").split(/[T\s]/)[0]}</td
                              >
                              <td
                                class={cliente.estado == "0"
                                  ? "fg-3 text-center "
                                  : "text-center "}
                              >
                                {cliente.probabilidad}%
                              </td>
                              <td class={cliente.estado == "0" ? "fg-3" : ""}>
                                {cliente.fecha_actualizacion ?? ""}
                              </td>
                              <td class="text-end">
                                {#if coincideEtapa(cliente, "Posible cliente") && cliente.clasificacion == "Nuevo"}
                                  <button
                                    class="btn btn-sm btn-solid theme-danger py-0 px-1"
                                    on:click={() => deleteCliente(cliente.id)}
                                  >
                                    <i class="bi bi-trash"></i>
                                  </button>
                                {/if}
                              </td>
                            </tr>
                          {/each}
                        {:else}
                          <tr>
                            <td colspan="10" class="text-center">
                              <SinInformacion
                                message="No hay clientes para mostrar"
                              />
                            </td>
                          </tr>
                        {/if}
                      </tbody>
                    </table>
                  </Datatable>
                {/key}
              {/if}
            </div>

            <div
              class="tab-pane fade"
              class:show={!modoAdmin && pestañaActiva === "segmentos"}
              class:active={!modoAdmin && pestañaActiva === "segmentos"}
              id="pills-segmentos-e"
              role="tabpanel"
              aria-labelledby="pills-segmentos-tab-e"
            >
              <Segmentos
                on:update={(event) => {
                  segmentosActivos = event.detail.filter(
                    (seg) => seg.estado == "1",
                  )
                }}
              />
            </div>

            <div
              class="tab-pane fade"
              class:show={!modoAdmin && pestañaActiva === "productos"}
              class:active={!modoAdmin && pestañaActiva === "productos"}
              id="pills-productos-e"
              role="tabpanel"
              aria-labelledby="pills-productos-tab-e"
            >
              <Productos segmentos={segmentosActivos} />
            </div>
          </div>

          <!-- Modales -->
          {#if modoAdmin && clienteConsulta}
            <ClienteConsulta
              clienteResumen={clienteConsulta}
              on:close={() => (clienteConsulta = null)}
            />
          {/if}
          <Modal
            isOpen={isOpenModalCliente}
            on:close={() => {
              isOpenModalCliente = false
              getClientes()
            }}
            title="Agregar cliente"
          >
            <AgregarCliente
              on:close={() => {
                isOpenModalCliente = false
                getClientes()
              }}
              on:update={getPuntos}
            />
          </Modal>
        </Container>
      </div>
      <Footer />
    </div>
  </main>
{/if}

<style>
  .page-shell {
    height: 100vh;
    height: 100dvh;
    overflow: hidden;
  }

  .page-content {
    min-width: 0;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
  }

  @media (max-width: 767.98px) {
    .page-shell {
      height: auto;
      min-height: 100vh;
      overflow: visible;
    }

    .page-content {
      overflow: visible;
    }
  }

  .alert.theme-warning {
    background-color: #fff6eb;
    border-color: #ff7800;
    color: #a84f00;
  }

  .td-hover:hover {
    background-color: #f8f9fa;
    cursor: pointer;
  }

  .limitar-texto {
    max-width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
